import { createZodDto } from 'nestjs-zod/dto';
import z from 'zod';
import { enumParser, PartnerOrganizationType } from '#validation';
export const CurrentUserPartnerOrganizationListSchema = z.array(z.object({
    id: z.uuid(),
    name: z.string(),
    type: enumParser(PartnerOrganizationType),
    billingUnits: z.array(z.object({
        id: z.uuid(),
        parentId: z.uuid().nullable(),
    })),
    parentOrganization: z
        .object({
        id: z.uuid(),
        name: z.string(),
    })
        .nullable(),
}));
export class CurrentUserPartnerOrganizationListDto extends createZodDto(CurrentUserPartnerOrganizationListSchema) {
}
